import React from 'react';
import styles from 'componets/light-box/index.module.scss';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

const LightBoxLayout = ({ show = false, children, className, onClose }) => {
  const mask = cx(className, {
    mask: true,
    show: show,
    hide: !show,
  });

  return (
    <div className={mask} onClick={onClose}>
      <div onClick={e => e.stopPropagation()} className={styles.box}>
        {children}
      </div>
    </div>
  );
};

export default LightBoxLayout;
